
import "../css/image.css";


function Image({link}){
    return(
    //<div className="sticky_image_wrapper">
        <img src={link} alt="ghe" className="img"></img>
    //</div>
    )
}

export default Image;

